import { Link } from 'react-router';
import imgChatzappLogo from '@/assets/fe97ce01718b87fd4112afe932d2c39290818a54.png';

export function Logo() {
  return (
    <Link to="/" className="flex items-center gap-0 h-[44px]">
      <div className="h-[44px] w-[68px] relative">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <img 
            alt="ChatZapp Logo" 
            className="absolute h-[223.53%] left-[-61.54%] max-w-none top-[-58.82%] w-[219.23%]" 
            src={imgChatzappLogo} 
          />
        </div>
      </div>
      <p 
        style={{ fontFamily: 'PT Sans', fontWeight: '600' }} 
        className="capitalize h-[41px] leading-[40px] text-[24px] text-white whitespace-pre-wrap"
      >
        CHATZAPP
      </p>
    </Link>
  );
}
